export const staffReducer = (state, action) => {
  switch (action.type) {
    case "loadStaff":
      console.log("nahom");
      return loadStaff(state, action.staffs);
    case "addStaff":
      console.log("adding");
      return addStaff(state, action.staff);
    case "editStaff":
      console.log("editing");
      return editStaff(state, action.staff);
    case "disableStaff":
      return disableStaff(state, action.staff);
    default:
      return state;
  }
};
const loadStaff = (state, staffs) => {
  console.log(staffs);
  let newState = [...staffs];
  return newState;
};
const addStaff = (state, staff) => {
  const newState = [
    ...state,
    {
      username: staff.username,
      id: staff.id,
      qualifications: staff.qualifications,
      start_date: staff.start_date,
    },
  ];
};

const editStaff = (state, staff) => {
  const newState = [...state];
  const index = newState.findIndex((c) => c.id === staff.id);
  newState[index] = {
    ...staff,
    department: "Software Engineering",
  };
  return newState;
};
const disableStaff = (state, staff) => {
  const newState = [...state];
  const index = newState.findIndex((c) => c.id === staff.id);
  newState[index] = {
    ...newState[index],
    end_date: staff.newDate,
  };
  return newState;
};
